import React, { useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../../../../constants/pagination'
import { useTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

// COMPONENT
import FilterSelect from '../../../../../../component/select/filterSelect';
import InputTextField from '../../../../../../component/input/inputTextField';
import { ButtonContained } from '../../../../../../component/mui-custom/MuiCustom';
import { setLoading, unsetLoading } from '../../../../../../store/slice/loading/loading.slice';
import { swalError, swalSuccess } from '../../../../../../component/notification/swal';

// API
import { StrategyApi, createStrategy } from '../../../../../../api/strategy/strategy.api';
import { FiscalYearApi } from '../../../../../../api/fiscal-year/fiscalyear.api';

type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    idStrategyRef: number;
    idStrategy: number;
}

const EditStrategy: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [fiscalYear, setFiscalYer] = useState<any[]>([]);
    const [strategy, setStrategy] = useState<createStrategy>({
        strategyNo: "",
        strategyName: "",
        strategyDesc: "",
        strategyStatus: t("STATUS.ACTIVE"),
        idFiscalYear: 0,
        idStrategyRef: props.idStrategyRef,
    })

    const handleGetFiscalYear = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setFiscalYer(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }

    const handleGetDetailStrategy = async () => {
        dispatch(setLoading())
        await StrategyApi.getDetailStrategy(props.idStrategy)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const { strategyNo, strategyName, strategyDesc, strategyStatus, idFiscalYear } = res.data?.result
                    setStrategy((prev) => ({
                        ...prev,
                        strategyNo,
                        strategyName,
                        strategyDesc,
                        strategyStatus,
                        idFiscalYear
                    }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })

    }
    const handleSubmit = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        console.log(strategy)
        await StrategyApi.updateStrategy(props.idStrategy, strategy)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                    props.toggleModal()
                } else {
                    swalError(res.response?.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
            .finally(() => {
                props.fetchData()
            })
    }

    useEffect(() => {
        handleGetDetailStrategy()
        handleGetFiscalYear()
    }, [])
    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='flex flex-col w-full mt-8 gap-5'>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setStrategy((prev) => ({ ...prev, strategyNo: e.target.value }))}
                        value={strategy.strategyNo}
                        heading='ลำดับยุทธศาสตร์'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setStrategy((prev) => ({ ...prev, strategyName: e.target.value }))}
                        value={strategy.strategyName}
                        heading='ชื่อยุทธศาสตร์'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setStrategy((prev) => ({ ...prev, strategyDesc: e.target.value }))}
                        value={strategy.strategyDesc}
                        heading='คำขยายความยุทธศาสตร์'
                    />
                </span>
                <span>
                    <FilterSelect
                        disabled
                        required
                        renderValue={() => fiscalYear.find((list: any) => list?.idFiscalYear === strategy.idFiscalYear)?.fiscalYear}
                        heading={t("ปีงบประมาณ")}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={strategy.idFiscalYear}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setStrategy((prev) => ({ ...prev, idFiscalYear: Number(event.target.value) }))}
                        options={fiscalYear && fiscalYear.map((list: any) => (
                            <MenuItem disabled={list?.fiscalYearStatus === false} key={list?.idFiscalYear} value={list?.idFiscalYear}>
                                <Typography>
                                    {list?.fiscalYear}
                                </Typography>
                            </MenuItem>
                        ))}
                    />
                </span>
                <span>
                    <FilterSelect
                        required
                        heading={t("สถานะ")}
                        renderValue={() => strategy.strategyStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={strategy.strategyStatus}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setStrategy((prev) => ({ ...prev, strategyStatus: event.target.value }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='mt-3 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default EditStrategy

